import React, { useState } from "react";
import ClinicalCongratsQBank from "../elements/clinicalcongratsqbank";
import ClinicalCongratsLearning from "../elements/clinicalcongratsslearning";
import ClinicalCongratsScore from "../elements/clinicalcongratsscore";
import SymptomChecker from "../elements/symptomchecker";
import LoadingScreen from "../elements/loading";
import SubjectsPopup from "../elements/subjectspopup";
import BadgePopup from "../elements/badge";
import ClinicalTryAgain from "../elements/clinicaltryagain";
import EmptyScreen from "../elements/emptyscreen";
import ClinicalCongrats from "../elements/clinicalcongrats";
import FreeTrial from "../elements/freetrial";
import SubscriptionLoader from "../elements/subscriptionloader";
import FreeTrialNew from "../elements/freetrialnew";
import OrderSummary from "../elements/ordersummary";

const Achivement1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/1.svg";
const Achivement2 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/2.svg";
const Achivement3 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/3.svg";
const Achivement4 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/4.svg";
const Achivement5 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/5.svg";
const Achivement6 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/6.svg";
const Achivement7 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/7.svg";
const Achivement8 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/8.svg";
const Achivement9 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/9.svg";
const Achivement10 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/10.svg";
const GapLine =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/line.svg";

export default function PopupTesting() {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const getBadgeData = (score) => {
    if (score >= 2500) {
      return {
        text: "The pinnacle of achievement! Your expertise lights the way for the future of healthcare.",
        imgSrc: Achivement10,
      };
    } else if (score >= 2000) {
      return {
        text: "A beacon of brilliance in the medical field, guiding others with your knowledge.",
        imgSrc: Achivement9,
      };
    } else if (score >= 1750) {
      return {
        text: "Casting spells of wisdom and healing with exceptional medical prowess.",
        imgSrc: Achivement8,
      };
    } else if (score >= 1500) {
      return {
        text: "Your dedication and skills are heroic, inspiring others to follow your lead.",
        imgSrc: Achivement7,
      };
    } else if (score >= 1250) {
      return {
        text: "You’re conquering challenges and standing strong in the fight against diseases.",
        imgSrc: Achivement6,
      };
    } else if (score >= 1000) {
      return {
        text: "Your expertise is taking off, showcasing advanced understanding in the field.",
        imgSrc: Achivement5,
      };
    } else if (score >= 500) {
      return {
        text: "Demonstrating mastery and growing into a true scholar of medicine.",
        imgSrc: Achivement4,
      };
    } else if (score >= 250) {
      return {
        text: "You’re building a solid foundation of medical knowledge. Keep striving for excellence!",
        imgSrc: Achivement3,
      };
    } else if (score >= 100) {
      return {
        text: "Gaining confidence and sharpening your skills. Keep the momentum going!",
        imgSrc: Achivement2,
      };
    } else if (score >= 50) {
      return {
        text: "Your journey begins! Step into the world of medical expertise with this first milestone.",
        imgSrc: Achivement1,
      };
    } else {
      return {
        text: "Keep going to unlock your first badge and start your journey in the world of medical expertise!",
        imgSrc: null,
      };
    }
  };
  const achievements = [
    {
      scoreThreshold: 50,
      imgSrc: Achivement1,
      alt: "Achievement 1",
      title: "Novice",
    },
    {
      scoreThreshold: 100,
      imgSrc: Achivement2,
      alt: "Achievement 2",
      title: "Apprentice",
    },
    {
      scoreThreshold: 250,
      imgSrc: Achivement3,
      alt: "Achievement 3",
      title: "MedExpert",
    },
    {
      scoreThreshold: 500,
      imgSrc: Achivement4,
      alt: "Achievement 4",
      title: "Scholar",
    },
    {
      scoreThreshold: 1000,
      imgSrc: Achivement5,
      alt: "Achievement 5",
      title: "Master Blaster",
    },
    {
      scoreThreshold: 1250,
      imgSrc: Achivement6,
      alt: "Achievement 6",
      title: "Disease Conqueror",
    },
    {
      scoreThreshold: 1500,
      imgSrc: Achivement7,
      alt: "Achievement 7",
      title: "Hero",
    },
    {
      scoreThreshold: 1750,
      imgSrc: Achivement8,
      alt: "Achievement 8",
      title: "Wizard",
    },
    {
      scoreThreshold: 2000,
      imgSrc: Achivement9,
      alt: "Achievement 9",
      title: "Luminary",
    },
    {
      scoreThreshold: 2500,
      imgSrc: Achivement10,
      alt: "Achievement 10",
      title: "Beacon Of Medicine",
    },
  ];
  const badgeData = getBadgeData(1000);
  return (
    <div>
      <button onClick={togglePopup}>Open Popup</button>
      <LoadingScreen loaderLine="" />
      <EmptyScreen />
      {/* <FreeTrialNew
        isVisible={isPopupVisible}
        onClose={togglePopup}
        header={"Processing Your Offer"}
      /> */}

      {/* <ClinicalCongratsLearning
        isVisible={isPopupVisible}
        onClose={togglePopup}
      /> */}
      {/* {<SubscriptionLoader isVisible={isPopupVisible} onClose={togglePopup} />} */}
      <OrderSummary isVisible={isPopupVisible} onClose={togglePopup} />
    </div>
  );
}
